import { Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Admin Portal';

  constructor(private swUpdate: SwUpdate) {
    if (swUpdate.isEnabled) {
      swUpdate.checkForUpdate().then((available) => {
        if (available) {
          if (confirm('New Version Available. Update to new version?')) {
            window.location.reload();
          }
        }
      });
    }
  }
}
